/* Layout */
import Layout from '@/views/layout/Layout';
import AppManage from '@/views/storeManage/appManage';
import AppDetail from '@/views/storeManage/appManage/appDetail';
import ProductManage from '@/views/storeManage/productManage';
import ProductDetail from '@/views/storeManage/productManage/productDetail';
import IntegralBenefits from '@/views/storeManage/IntegralBenefits';
import OrderManage from '@/views/storeManage/orderManage';
import OrderDetails from '@/views/storeManage/orderManage/details';
import StoreSettings from '@/views/storeManage/storeSettings';
const storeManageRouter = {
  path: '/manage/stores',
  component: Layout,
  props: true,
  type: 'sellers',
  name: 'Stores',
  meta: {
    title: '商店管理',
    icon: 'shop-management',
    requiresAuth: true,
    role: 'market'
  },
  redirect: '/manage/stores/templates',
  hidden: false,
  children: [
    {
      path: 'templates',
      name: 'templateManage',
      component: AppManage,
      meta: {
        title: '模版管理',
        icon: 'template',
        requiresAuth: true,
        role: 'market',
        perms: ['Market.Application.List', 'Market.Application.SelfList'] // 满足一个即可
      },
      hidden: false
    },
    {
      path: 'templates/:appID/:tabMode',
      name: 'StoreTemplateManageDetails',
      component: AppDetail,
      meta: {
        title: '模版详情',
        requiresAuth: true,
        role: 'market',
        currentActive: '/manage/stores/templates',
        perms: ['Market.Application.Get']
      },
      hidden: true
    },
    {
      path: 'products',
      name: 'productManage',
      component: ProductManage,
      meta: {
        title: '商品管理',
        icon: 'product-cate',
        requiresAuth: true,
        role: 'market'
      },
      hidden: false
    },
    {
      path: 'products/:productID/:tabMode',
      name: 'StoreProductManageDetails',
      component: ProductDetail,
      meta: {
        title: '商品详情',
        requiresAuth: true,
        role: 'market',
        currentActive: '/manage/stores/products'
      },
      hidden: true
    },
    {
      path: 'orders/:orderState',
      name: 'storOrderManage',
      component: OrderManage,
      meta: {
        title: '订单管理',
        icon: 'order',
        requiresAuth: true,
        role: 'market',
        perms: ['Market.Order.List']
      },
      hidden: false
    },
    {
      path: ':marketID/orders/:orderID/details',
      name: 'storeOrderDetails',
      component: OrderDetails,
      meta: {
        title: '订单管理详情',
        icon: 'order',
        requiresAuth: true,
        role: 'market',
        perms: ['Market.Order.Get'],
        currentActive: '/manage/stores/orders/all'
      },
      hidden: true
    },
    {
      path: 'integral',
      name: 'marketIntegral',
      component: IntegralBenefits,
      meta: {
        title: '金额收益',
        icon: 'enterprise-integration',
        requiresAuth: true,
        perms: ['Market.Payment.List'],
        role: 'market'
      },
      hidden: false
    },
    {
      path: 'settings',
      name: 'storeSettings',
      component: StoreSettings,
      meta: {
        title: '商店设置',
        icon: 'store-settings',
        requiresAuth: true,
        perms: ['Market.MarketSetting'],
        role: 'market'
      },
      hidden: false
    }
  ]
};

export default storeManageRouter;



// WEBPACK FOOTER //
// ./src/router/modules/storeManage.js